import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./consts";

// Мову задає виключно префікс в URL. Відсутність префікса — це не "невідомо", а DEFAULT_LANGUAGE
const getLanguageFromUrl = () => {
  const currentUrl = new URL(document.location);
  let language = DEFAULT_LANGUAGE;

  Object.keys(SUPPORTED_LANGUAGES).forEach(supportedLanguage => {
    const matches = currentUrl.href.match(`(^${currentUrl.origin.replaceAll("/", "\\/")}${SUPPORTED_LANGUAGES[supportedLanguage].regex})`);

    if (matches && matches[0] !== "" && matches[1] !== "") {
      language = supportedLanguage;
    }
  });

  return language;
};

export default getLanguageFromUrl;